import { Separator } from "@base-ui/react";
import { Fragment, type ReactNode } from "react";
import { Link } from "react-router-dom";

import { TenkoLineSkeleton } from "../feedback/TenkoSkeleton";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "../primitives/breadcrumb";
import { SidebarTrigger } from "../primitives/sidebar";
import { useAppShellBreadcrumbItems } from "./useAppShellBreadcrumb";

export type TenkoAppShellHeaderProps = {
  actions?: ReactNode;
};

export function TenkoAppShellHeader({ actions }: TenkoAppShellHeaderProps) {
  const items = useAppShellBreadcrumbItems();

  return (
    <header className="flex h-16 shrink-0 items-center gap-2 border-b">
      <div className="flex items-center gap-2 px-4">
        <SidebarTrigger className="-ml-1" />
        {items.length > 0 ? (
          <>
            <Separator orientation="vertical" className="mr-2 data-[orientation=vertical]:h-4 self-center!" />
            <Breadcrumb>
              <BreadcrumbList>
                {items.map((item, index) => {
                  const isLast = index === items.length - 1;
                  const content = item.loading ? (
                    <TenkoLineSkeleton className="h-4 w-24 inline-block align-middle" />
                  ) : (
                    item.label
                  );
                  return (
                    <Fragment key={`${item.label}-${index}`}>
                      <BreadcrumbItem className={index < items.length - 1 ? "hidden md:block" : undefined}>
                        {isLast || !item.to || item.loading ? (
                          <BreadcrumbPage>{content}</BreadcrumbPage>
                        ) : (
                          <BreadcrumbLink render={<Link to={item.to} />}>{content}</BreadcrumbLink>
                        )}
                      </BreadcrumbItem>
                      {!isLast ? <BreadcrumbSeparator className="hidden md:block" /> : null}
                    </Fragment>
                  );
                })}
              </BreadcrumbList>
            </Breadcrumb>
          </>
        ) : null}
      </div>
      {actions ? <div className="ml-auto flex items-center gap-2 px-4">{actions}</div> : null}
    </header>
  );
}
